module.exports = __webpack_public_path__ + "second-life-01-ita.jpg?7cbafbb38501ece37251006125e3fcdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/second-life-01-ita.jpg
// module id = 256
// module chunks = 0